import React from "react";
import { FaLocationArrow, FaEnvelope, FaPhone } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-full bg-white">
      <div className="w-full flex flex-col px-6 pt-20 lg:px-10 xl:px-24">
        <div className="text-zinc-600 cursor-default lg:flex lg:flex-row lg:gap-x-16 justify-center border-t border-zinc-200">
          {/* Company Section */}
          <div className="text-center lg:text-left mb-10 lg:mb-0">
            <h2 className="text-2xl text-zinc-800 font-mono font-bold">GOMP</h2>
            <ul className="mt-4 text-sm flex flex-col items-center lg:items-start justify-start gap-2">
              <li className="flex flex-row items-start justify-center lg:justify-start">
                <span>
                  <FaLocationArrow className="w-4 h-4 mr-1 mt-1 fill-zinc-600" />
                </span>
                <p className="font-inter">
                  2 Burns House,
                  <br />
                  Axminster Crescent
                  <br />
                  London
                  <br />
                  DA16 1EY
                </p>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="text-center lg:text-left mb-10 lg:mb-0">
            <h2 className="font-mono font-bold text-zinc-700 text-lg">
              Contact
            </h2>
            <ul className="mt-4 text-sm">
              <li className="flex items-start justify-center lg:justify-start">
                <p className="text-left text-zinc-600 break-words ">
                  Company Registration
                  <br />
                  Get Off My Pavement LTD
                  <br />
                  16165959
                  <br />
                </p>
              </li>
              <br />
              <li className="flex items-start justify-center lg:justify-start">
                <span>
                  <FaEnvelope className="w-4 h-4 mr-1 mt-1 fill-zinc-600" />
                </span>
                <a
                  target="javascript:;"
                  className="text-left text-zinc-600 break-words hover:underline hover:text-zinc-800"
                  href="mailto:contact@techsolutionsco.net"
                >
                  info@getoffMypavement.co.uk
                </a>
              </li>
              <li className="flex items-start justify-center lg:justify-start">
                <span>
                  <FaPhone className="w-4 h-4 mr-1 mt-1 fill-zinc-600" />
                </span>
                <p className="text-left text-zinc-600 break-words ">
                  07789 119 299{" "}
                </p>
              </li>
            </ul>
          </div>

          {/* Data Protection Policy Section */}
          <div className="text-center lg:text-left">
            <h2 className="font-mono font-bold text-zinc-700 text-lg">
              Data Protection Policy  
            </h2>
            <ul className="mt-4 text-sm">
              <li className="flex items-start justify-center lg:justify-start">
                <Link
                  className="text-left text-zinc-600 break-words hover:underline hover:text-zinc-800"
                  to="/data-protection-policy"
                >
                  Data Protection Policy
                </Link>
              </li>
              <li className="flex items-start justify-center lg:justify-start">
                <Link
                  className="text-left text-zinc-600 break-words hover:underline hover:text-zinc-800"
                  to="/terms-and-conditions"
                >
                  Terms and Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="w-full mt-10 py-10 border-t border-zinc-200 font-inter text-center text-xs text-zinc-400">
          Copyright © 2024 Tech Solutions Co. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
